import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState, useAppDispatch } from "store";

interface ProtectedRouteProps {
  children: React.ReactNode;
  permissions?: string[];
}

function ProtectedRoute({ children, permissions }: ProtectedRouteProps): React.ReactElement | null {
  const userContext = useSelector((state: RootState) => state.core.userContext?.userContext);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch({ type: "loader/showandhide", payload: { show: !userContext } });
  }, [userContext, dispatch]);

  const isAuthorized = () => {
    if (!!userContext && permissions && permissions.length > 0) {
      const userHasPermission = permissions?.some(
        (permission) =>
          userContext?.permissions &&
          userContext.permissions.length > 0 &&
          userContext.permissions.includes(permission),
      );
      return userHasPermission;
    }
    return true;
  };

  const isContentPage = location.pathname.toLowerCase().indexOf("/player") === -1;

  // For content pages, wait for userContext to load before making authorization decision
  if (!userContext && isContentPage) {
    return null; // Loader is shown via dispatch
  }

  // Check authorization after userContext has loaded
  if (!isAuthorized()) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
